import { immer } from 'zustand/middleware/immer';
import { createStore } from 'zustand/vanilla';

// Utils
import { setDatepickerGlobalLocalStorage } from '@/utils/localStorage/datepickerGlobalLocalStorage';

// Types
import type {
    DatepickerComparisonPeriodsAvailableType,
    DatepickerGlobalPeriodsType
} from '@/lib/periods';

export type DatepickerGlobalStoreStateType = {
    date: { from: Date; to: Date };
    period: DatepickerGlobalPeriodsType;
    compareTo: DatepickerComparisonPeriodsAvailableType;
};

export type DatepickerGlobalStoreActionsType = {
    updateDatepickerDate: (data: Pick<DatepickerGlobalStoreStateType, 'date' | 'period'>) => void;
    updateDatepickerCompareTo: (compareTo: DatepickerGlobalStoreStateType['compareTo']) => void;
};

export type DatepickerGlobalStoreType = DatepickerGlobalStoreStateType &
    DatepickerGlobalStoreActionsType;

export const createDatepickerGlobalStore = (initState: DatepickerGlobalStoreStateType) => {
    return createStore<DatepickerGlobalStoreType>()(
        immer((set) => ({
            ...initState,
            updateDatepickerDate: (data) => {
                set((state) => {
                    state.date = data.date;
                    state.period = data.period;
                    setDatepickerGlobalLocalStorage({ ...state, ...data });
                });
            },
            updateDatepickerCompareTo: (compareTo) => {
                set((state) => {
                    state.compareTo = compareTo;
                    setDatepickerGlobalLocalStorage({ ...state, compareTo });
                });
            }
        }))
    );
};
